const ProgressBarSize = {
  Tiny: 'tiny',
};

export default ProgressBarSize;
